<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf">
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" name='keyword'>
          <!-- <a-input-group compact :style="{width:'260px'}">
            <a-select v-model:value="search.select" style="width: 30%">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="Option1">卡券ID</a-select-option>
              <a-select-option value="Option2">领取人ID</a-select-option>
              <a-select-option value="Option2">购物券订单号</a-select-option>
              <a-select-option value="Option2">券码</a-select-option>
            </a-select> -->
            <a-input style="width: 70%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
          <!-- </a-input-group> -->
        </a-form-item>
        <a-form-item label="券状态" name='status'>
          <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">正常</a-select-option>
            <a-select-option value="beijing">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="来源类型" name='type'>
          <a-select v-model:value="search.type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">直接发放</a-select-option>
            <a-select-option value="2">积分兑换</a-select-option>
            <a-select-option value="3">小程序派券</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="使用时间" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导出</a-button>
        </a-form-item> -->
      </a-form>
      <div class="s_c333 fz-16 s_font_b m-b-20">发放总面值： <span style="color: #D32500;">{{price_total}}</span>元</div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
            <template v-slot:valid_time="{ record }">
          <p>{{record.coupon.valid_time}}</p>
        </template>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <router-link :to="'/agent/agent_level/detail?type=look&id='+record.id">
                    <a href="javascript:;">详情</a>
                  </router-link>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:agentEdit="()=> agentAdd(record)" href="javascript:;">核销</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </div>
  </a-layout>
  <a-modal  :keyboard="false" title="核销确认" centered v-model:visible="visible" destroyOnClose okText='核销'>
    <p class="s_c333 m-b-20 fz-16 s_font_b">确定要对编码为“SM4039164633036”的优惠券做核销操作吗？</p>
    <p class="s_cd41">(一经核销，优惠券即为已使用状态，不能再次使用)</p>
  </a-modal>
  
</template>
<script>
import { DownOutlined } from "@ant-design/icons-vue";
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getCouponGrantList } from "@/api/assets";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  type: '',
  page: 1,
  limit: 10,
  start_time:'',
  end_time:'',
  status:'',
  select:''
};
export default {
  name:'grantList',
  components: { DownOutlined },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      visible:false,
      time:[],
      price_total:0,
      total: 1
    });
    let columns = [
      {
        title: "领取人OpenID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "卡券ID",
        dataIndex: "coupon_id",
        key: "coupon_id",
      },
      {
        title: "券码",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "面值",
        dataIndex: "coupon",
        key: "coupon",
        customRender:({record})=>{
          return record.coupon.price
        }
      },
      {
        title: "发放类型",
        dataIndex: "source_type",
        key: "source_type",
      },
      {
        title: "发放时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "券状态",
        dataIndex: "is_use",
        key: "is_use",
        customRender:({text})=>{
          return text==0?"未使用":text==1?"已使用":'已过期'
        }
      },
      {
        title: "有效期",
        dataIndex: "time_type",
         key: "time_type",
        slots: { customRender: "time_type" },
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject('$router')
    const $Modal = inject('$Modal')

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0]
      search.value.end_time = e[1]
      initData(search.value);
    }
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getCouponGrantList(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
          state.price_total=res.data.price_total
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    
    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange
      
    };
  },
};
</script>